<template>
    <div class="painelCinza">
        <b-container class="bv-example-row">
            <b-row>
                <b-col>
                    <h6><b>{{ $t('label.painel_adm') }}</b></h6>
                </b-col>
            </b-row>
            <br>
            <br>
            <b-row>
                <b-col>
                    <b-card border-variant="dark" class="text-center">
                        <h5>{{ $t('label.metodo_pagamento') }}</h5>
                        <span class="info-icon" tabindex="0" v-b-tooltip.hover title="Selecione o(s) método(s) de pagamento que ficarão disponíveis no site">❓</span>

                        <br>
                        <b-form-group label="Selecione um método:" label-for="metodo-pagamento-dropdown">
                            <br>
                            <b-form-select id="metodo-pagamento-dropdown" v-model="metodoPagamento" :options="opcoesPagamento"></b-form-select>
                            <br>
                            <br>
                            <b-button variant="success" @click="salvarMetodoPagamento">{{ $t('botao.salvar') }}</b-button>
                            <br>
                        </b-form-group>
                    </b-card>
                </b-col>
                <b-col></b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { praca } from '../config.js';

import BaseMixin from '../mixins/BaseMixin';
import MetodosAuxiliares from "@/helper/MetodosAuxiliares";
import CartaoService from "@/services/CartaoService";
import LoginService from "@/services/LoginService";
import CartaoValidator from "@/models/validator/CartaoValidator";
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
    mixins: [BaseMixin],
    data() {
        return {
            cartaoService: new CartaoService(),
            loginService: new LoginService(),
            cartaoValidator: new CartaoValidator(),
            metodosAuxiliares: new MetodosAuxiliares(),

            aux: praca,

            login: '',
            senha: '',
            
            metodoPagamento: null, 
            opcoesPagamento: [     
                { value: null, text: 'Selecione um método' },
                { value: 'pix', text: 'Pix' },
                { value: 'boleto', text: 'Boleto' },
                { value: 'boleto-pix', text: 'Boleto e Pix' },
            ],
        };
    },

    created() {
        this.configBreadCrumb({
            botoesAcao: {
                salvar: false,
                voltar: true
            }
        });
    },

    computed: {
        ...mapGetters('SolicitacoesStore', ['FiltroSolicitacoes']),
        ...mapState('SolicitacoesStore', ['FiltroSolicitacoes']),
        ...mapGetters('cartaoStore', ['Cartao']),
        ...mapState('cartaoStore', ['Cartao']),
    },

    mounted() {
        this.FiltroHomeLocal = Object.assign({}, this.FiltroHome)
        localStorage.setItem('token', '')
    },

    methods: {
        ...mapActions('cartaoStore', ['updateStateCartao']),

        async efetuaLogin(login, senha) {
            try {
                this.metodosAuxiliares.IsLoginAdm(login)
                this.metodosAuxiliares.IsSenhaAdm(senha)
                this.redirectSolicitacoes()
            } catch (error) {
                this.flagValidouOK = false;
                this.criaModalMensagem({ titulo: this.$t("label.aviso"), descricao: this.$t(error.message) }, null, null);
            }
        },

        voltar() {
            this.$router.push({ name: "Home" });
        },

        async redirectSolicitacoes() {
            this.$router.push({ name: "AdmPainel" });
        },

        salvarMetodoPagamento() {
        }
    }
}
</script>

<style>
.info-icon {
    cursor: pointer;
    margin-left: 5px;
}
</style>
